import { compose } from 'recompose';
import SelectInput from '@/se/components/inputs/SelectInput';
import { list } from '@/graph/config';
import { ConfigType } from '@/types/HospitalConfig';
import React from 'react';
import { useQuery } from '@apollo/client';
import { withLabel } from '@/se/components/Label';

const LabeledSelectInput = compose(withLabel('Title'))(SelectInput);

const TitleSelectInput = ({ value, onChange }) => {
  const selectedValue = value && JSON.parse(value)?.abbr;

  const { data } = useQuery(list, {
    variables: {
      type: ConfigType.StaffTitle,
    },
  });

  const options = data?.configs?.reduce((acc, curr) => {
    const parsed = curr?.values && JSON.parse(curr?.values);
    return parsed ? { ...acc, [parsed?.abbr]: parsed?.title } : acc;
  }, {});

  const byAbbr = data?.configs?.reduce((acc, curr) => {
    const parsed = curr?.values && JSON.parse(curr?.values);
    return parsed ? { ...acc, [parsed?.abbr]: parsed } : acc;
  }, {});

  return (
    <LabeledSelectInput
      /* @ts-ignore */
      placeholder={'e.g., Registered Nurse'}
      required={false}
      value={selectedValue}
      onChange={val => {
        const cfg = byAbbr?.[val] || {};
        onChange(JSON.stringify({ title: options[val], abbr: val, roleClassification: cfg?.roleClassification, department: cfg?.department }));
      }}
      options={options}
    />
  );
};

export default TitleSelectInput;
